import { DELETE, GET, POST } from '../common/common.service'
import endpointsNotificationsFuelStations from './endpoints'

export const NotificationsFuelStationService = {
  getAllModulesUsers: async ({ filter, sort, limit, skip }) =>
    GET(endpointsNotificationsFuelStations.LOAD(filter, sort, limit, skip)),
  addUser: async (id, body) =>
    POST(endpointsNotificationsFuelStations.ADD(id), body),
  removeUser: async (id, userId) =>
    DELETE(endpointsNotificationsFuelStations.REMOVE(id, userId)),
}
